import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { AsYouType } from 'libphonenumber-js';

@Component({
  selector: 'app-contact-link',
  templateUrl: './contact-link.component.html',
  styleUrls: ['./contact-link.component.scss']
})
export class ContactLinkComponent implements OnInit, OnChanges {
  /** null draws placeholder */
  @Input() email?: string | null;
  /** null draws placeholder */
  @Input() phone?: string | null;

  @Input() theme: 'default' | 'tiny' = 'default';

  public icon = '';
  public prefix = '';
  public data = '';
  public formatted = '';

  private formatter = new AsYouType('PL');

  constructor() {}

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.email?.currentValue !== undefined) {
      this.icon = 'email';
      this.prefix = 'mailto';
      this.data = changes.email.currentValue;
      this.formatted = this.data;
    } else if (changes.phone?.currentValue !== undefined) {
      this.icon = 'phone';
      this.prefix = 'tel';
      this.data = changes.phone.currentValue;
      this.formatted = this.data ? this.formatter.input(this.data) : '';
      this.formatter.reset();
    }
  }
}
